import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectCategoryDescriptionInStore,
  selectCategoryDescriptionPageLoading,
  selectCategoryDescriptionShowInitWaitingMessage,
} from '../_selectors/category-description.selectors';

export class CategoryDescriptionDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectCategoryDescriptionPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectCategoryDescriptionShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectCategoryDescriptionInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
